import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: null,
};

const wpsGenerateSalarySlice = createSlice({
  name: "wpsGenerateSalary",
  initialState,
  reducers: {
    setData: (state, action) => {
      if (action.payload) state.data = action.payload;
    },
    resetData: (state) => {
      state.data = null;
    },
    updateRecord: (state, action) => {
      const { updatedRecord } = action.payload;

      state.data.salaryStructure = state.data.salaryStructure.map((record) =>
        record.employeeId === updatedRecord.employeeId
          ? { ...record, ...updatedRecord }
          : record
      );

      state.data.scrDetails[0].totalSalary = updatedRecord.totalSalary;
    },
  },
});

export const { setData, resetData, updateRecord } =
  wpsGenerateSalarySlice.actions;
export const wpsGenerateSalaryReducer = wpsGenerateSalarySlice.reducer;
export default wpsGenerateSalarySlice;
